import React, { useState, useEffect } from "react";
import { Input, TextArea, RadioOptions, SaveProgress } from "components";
import { P, Button, FlexRow, FlexColumn, FlexRight, H2 } from "appStyles";
import { css } from "react-emotion";
import NumberFormat from "react-number-format";
import { updateAdvancedStoreTemplate } from "apis";
import Modal from "@material-ui/core/Modal";

import { storeRedemptionTypeOptions } from "constants";
import CloseIcon from "@material-ui/icons/Close";
import Switch from "@material-ui/core/Switch";

const titleStyle = css`
  white-space: nowrap;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
`;
const mdcButton = css`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

function AdvStore({
  toggleAdvancedSettingsModal,
  advancedSettings,
  appId,
  templateId,
  featuresRedemptionType,
  props,
}) {
  const [advancedSettingsState, setAdvancedSettingsState] = useState(
    advancedSettings
  );
  const [state, setState] = React.useState({
    checkedA: true,
    checkedB: true,
  });
  const [showAddressInput, setAddressInput] = useState(false);
  const [showRedemptionTypes, setShowRedemptionTypes] = useState(false);
  const [addressType, setAddressType] = useState("");
  const [showShippingFreeAfter, setShippingFreeAfter] = useState(
    advancedSettings.shippingFreeAfter
  );

  const [showDeliveryFreeAfter, setDeliveryFreeAfter] = useState(
    advancedSettings.deliveryFreeAfter
  );

  const toggleShowShippingFree = () => {
    setShippingFreeAfter(!showShippingFreeAfter);
  };
  const toggleShowDeliveryFree = () => {
    setDeliveryFreeAfter(!showDeliveryFreeAfter);
  };

  const saveAdvancedSettings = async (appId, templateId) => {
    let advancedStoreTemplate;
    if (!showShippingFreeAfter) {
      advancedStoreTemplate = {
        appId: appId,
        templateId: templateId,
        ...advancedSettingsState,
        shippingFreeAfter: -1,
      };
    } else if (!showDeliveryFreeAfter) {
      advancedStoreTemplate = {
        appId: appId,
        templateId: templateId,
        ...advancedSettingsState,
        deliveryFreeAfter: -1,
      };
    } else {
      advancedStoreTemplate = {
        appId: appId,
        templateId: templateId,
        ...advancedSettingsState,
      };
    }

    // console.log("sending packaged body");
    // console.log(advancedStoreTemplate);
    try {
      const result = await updateAdvancedStoreTemplate(advancedStoreTemplate);
      toggleAdvancedSettingsModal();
    } catch (e) {
      console.error(e);
    }
  };
  // console.log("printing advanced settings state");
  // console.dir(advancedSettingsState);

  const isTruthyFalsey = (field, value) => {
    if (
      field === "allowCustomizedPurchases" ||
      field === "deliveryAvailable" ||
      field === "pickupAvailable" ||
      field === "shippingAvailable"
    ) {
      if (value === 1) {
        return true;
      } else return false;
    }
    return value;
  };
  var formatDollarsToCents = function (value) {
    if (!value) return null;
    value = (value + "").replace(/[^\d.-]/g, "");
    if (value && value.includes(".")) {
      value = value.substring(0, value.indexOf(".") + 3);
    }

    return value ? Math.round(parseFloat(value) * 100) : 0;
  };

  const handleChange = (event) => {
    setAdvancedSettingsState({
      ...advancedSettingsState,
      [event.target.name]: event.target.checked,
    });
  };

  const update = (field) => (value) => {
    value = isTruthyFalsey(field, value);
    // console.log("updating " + field + " to " + value);
    if (field === "deliveryRadius") {
      value = parseInt(value["floatValue"]);
    }
    if (
      field === "shippingFreeAfter" ||
      field === "additionalShippingCost" ||
      field === "deliveryFreeAfter" ||
      field === "additionalDeliveryCost"
    ) {
      value = formatDollarsToCents(value["value"]);
    }
    setAdvancedSettingsState({
      ...advancedSettingsState,
      [field]: value,
    });
  };

  const updateAddress = (field, value) => {
    // console.log("updating " + field + " to " + value);
    setAdvancedSettingsState({
      ...advancedSettingsState,
      [field]: value,
    });
  };

  const toggleAddressInput = (type) => {
    setAddressType(type);
    setAddressInput(!showAddressInput);
  };

  const toggleRedemptionTypes = () => {
    setShowRedemptionTypes(!showRedemptionTypes);
  };

  const featuresRedemptionTypeString = () => {
    if (featuresRedemptionType != undefined) {
      return (
        <span
          className={titleStyle}
          style={{
            color: "#89d2d3",
            fontWeight: "bold",
            marginRight: "20px",
          }}
        >
          {featuresRedemptionType === 0 ? "None" : null}
          {featuresRedemptionType === 1 ? "Password Entry" : null}
          {featuresRedemptionType === 2 ? "Customer Scans Your QR Code" : null}
          {featuresRedemptionType === 3 ? "You Scan Customer’s QR Code" : null}
        </span>
      );
    }
  };

  const updateRedemptionType = (field) => (value) => {
    props.actions.updateApplication(field, value);
  };

  const getRedemptionTypeModalHeight = () => {
    switch (featuresRedemptionType) {
      case 0:
        return "600px";
      case 1:
        return "650px";
      case 2:
        return "765px";
      case 3:
        return "600px";
      default:
      // code block
    }
  };

  const renderRedemptionTypesModal = () => {
    if (!showRedemptionTypes) return null;
    const isManual = featuresRedemptionType == 1;
    const isCustomerScans = featuresRedemptionType == 2;
    const height = getRedemptionTypeModalHeight();
    return (
      <Modal
        open={showRedemptionTypes}
        onClose={toggleRedemptionTypes}
        style={{
          top: "2%",
          width: "50%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "20px",
            overflowY: "auto",
            height: height,
            borderRadius: "5px",
          }}
        >
          <div>
            <div
              style={{
                padding: "1em",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <P
                style={{
                  color: "black",
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontStretch: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textTransform: "none",
                  width: "auto",
                }}
              >
                Store Item Redemption Type
              </P>
              <span
                style={{
                  cursor: "pointer",
                  // marginLeft: "660px",
                  color: "black",
                  fontSize: "22px",
                }}
                onClick={toggleRedemptionTypes}
              >
                <CloseIcon fontSize={"large"}></CloseIcon>
              </span>
            </div>
          </div>
          <p
            style={{
              fontSize: "12px",
              lineHeight: "14px",
              color: "#8C8C8C",
              margin: "15px 5px",
            }}
            className="dealPassword"
          >
            Select how customers can redeem their purchases in the app
          </p>
          <FlexRow width="100%" style={{ height: "auto" }}>
            <RadioOptions
              {...props}
              value={featuresRedemptionType}
              options={storeRedemptionTypeOptions}
              setValue={updateRedemptionType("featuresRedemptionType")}
              showPasswordInput={isManual}
              showQRCode={isCustomerScans}
              pageType="featuresRedemption"
            ></RadioOptions>
          </FlexRow>
          <SaveProgress />
        </div>
      </Modal>
    );
  };

  const { allowCustomizedPurchases } = advancedSettingsState;

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "1em",
        color: "black",
        overflow: "scroll",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          padding: "1em",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <P
          style={{
            color: "black",
            fontSize: "30px",
            fontWeight: "bold",
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: "normal",
            letterSpacing: "normal",
            textTransform: "none",
            width: "auto",
          }}
        >
          Store Settings
        </P>
        <span
          style={{
            cursor: "pointer",
            // marginLeft: "660px",
            color: "black",
            fontSize: "22px",
          }}
          onClick={toggleAdvancedSettingsModal}
        >
          <CloseIcon fontSize={"large"}></CloseIcon>
        </span>
      </div>
      <FlexRow style={{ alignItems: "baseline", height: "initial" }}>
        <FlexColumn
          style={{
            margin: "0px 20px",
            alignItems: "flex-start",
          }}
        >
          <div>
            <div>
              <span className={titleStyle} style={{ marginRight: "20px" }}>
                Store Redemption Type:
              </span>
              {featuresRedemptionTypeString()}
              <Button
                style={{
                  width: "70px",
                  display: "inline-block",
                  margin: "0px",
                  textAlign: "center",
                  height: "42px",
                }}
                className={mdcButton}
                onClick={() => toggleRedemptionTypes()}
              >
                Edit
              </Button>
            </div>
          </div>
          <hr
            style={{
              borderTop: "2px dotted #89d2d3",
              margin: "20px 0px",
              width: "100%",
            }}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p
              style={{
                fontSize: "15px",
                margin: "13px 15px 15px 0px",
              }}
            >
              Allow customers to upload their grocery list only (no sales).
            </p>

            <Switch
              checked={allowCustomizedPurchases}
              onChange={handleChange}
              color="primary"
              name="allowCustomizedPurchases"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </div>
        </FlexColumn>
      </FlexRow>
      <FlexRight style={{ alignSelf: "flex-end", margin: "10px" }}>
        <Button
          style={{
            width: "100px",
            display: "inline-block",
            margin: "0px",
            textAlign: "center",
            marginLeft: "20px",
            height: "42px",
            margin: "0px 10px 0px 0px",
            backgroundColor: "#F17F7F",
          }}
          className={mdcButton}
          onClick={toggleAdvancedSettingsModal}
        >
          Cancel
        </Button>
        <Button
          style={{
            width: "100px",
            display: "inline-block",
            margin: "0px",
            textAlign: "center",
            marginLeft: "20px",
            height: "42px",
          }}
          className={mdcButton}
          onClick={saveAdvancedSettings}
        >
          Save
        </Button>
      </FlexRight>

      {renderRedemptionTypesModal()}
    </div>
  );
}

export default AdvStore;
